import React, { useMemo } from "react";
import Select from "react-select";

const SearchableDropdown = ({ placeholder, options, label, value, error, onSelect, disabled, isRequired = true }) => {
  // Format options for react-select
  const formattedOptions = useMemo(() => {
    return (options || []).map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [options]);

  // Memoize selected option from value
  const selectedOption = useMemo(() => {
    return formattedOptions.find((opt) => (String(opt.label).toLowerCase() === String(value).toLowerCase() || (label == "Select City" && String(opt.label).toLowerCase().includes(String(value).toLowerCase())))) || null;
  }, [value, formattedOptions]);

  const handleChange = (selected) => {
    const selectedRaw = (options || []).find((item) => item.name === selected?.label);
    if (onSelect) onSelect(selectedRaw.name == value ? null : selectedRaw)
  };

  return (
    <div className="mb-1 mx-1 search-select" key={(options || []).length}>
      {label && <label className="input-label mb-1">{label} {isRequired ? <span className="text-danger" style={{ fontSize: "14px" }}><sup>*</sup></span> : null}</label>}
      <Select
        classNamePrefix="my-select"
        isSearchable
        isDisabled={disabled}
        className={`input-box ${error ? "input-error" : ""}`}
        placeholder={placeholder}
        options={formattedOptions}
        value={selectedOption}
        onChange={handleChange}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            minHeight: '40px',
          }),
        }}
      />
      {error && <div className="error-message mt-1">{error}</div>}
    </div>
  );
};

export default SearchableDropdown;